// Shared styles used in tours index
// Todo: move to a higher level once tours tab is refactored completely
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grid } from 'views/anyguide/messages/styles';
import { colors } from 'ui_system/compass';
import { Theme } from 'ui_system/theme';

const { isIE } = window.mobileDetect;
const { isEdge } = window.mobileDetect;
const isMobile = !!window.mobileDetect.mobile();

export { Theme, isIE, isMobile, isEdge, Grid };

export const TourIndexContainer = styled.div`
  padding-bottom: 90px;
  @media (max-width: 420px) {
    padding-bottom: 30px;
  }
`;

export const PlusIcon = styled.div`
  font-size: 30px;
  line-height: 16px;
  margin-right: 15px;
`;

export const BaseInput = styled.input`
  width: 100%;
  padding: 14px 12px;
  border: 1px solid ${Theme.colors.inputs.border};
  font-size: 14px;
  line-height: 100%;
`;

export const ThemeButton = styled.a`
  background-color: ${Theme.colors.linksDesignElementsBaseColor};
  border: 1px solid ${Theme.colors.linksDesignElementsBaseColor};
  color: white;
  padding: 10px 18px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;

  /* Strip annoying <a> styling */
  :visited,
  :hover,
  :active {
    color: white;
  }

  :hover {
    background-color: ${Theme.colors.buttonHoverColor};
  }

  i {
    font-size: 14px;
    line-height: 14px;
    margin-right: 10px;
    font-weight: 600;
  }
  @media (max-width: ${Theme.mobile.mobileBreakpointWidth}px) {
    font-size: 12px;
  }

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: default;
  `}
`;

export const WhiteButton = styled(ThemeButton)`
  background-color: white;
  color: #4d4d4d;
  border: 1px solid ${colors.borderAction};
  font-weight: 400;

  /* Strip annoying <a> styling */
  :visited,
  :hover,
  :active {
    color: #4d4d4d;
  }
  :hover {
    background-color: ${colors.background.light};
  }
`;

export const FilterButton = styled.div`
  background-color: ${(props) =>
    props.applied ? `${colors.background.light}` : 'white'};
  border: ${(props) => (props.applied ? '2px' : '1px')} solid
    ${colors.borderAction};
  color: ${Theme.colors.primaryTextColor};
  padding-top: 7px;
  padding-bottom: 7px;
  padding-right: 25px;
  padding-left: 25px;
  width: fit-content;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  text-transform: capitalize;

  :hover {
    background-color: ${colors.background.light};
  }

  :focus {
    outline: 0;
  }
`;

export const ActionLinkCss = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: ${Theme.fontFamily.primary};
  padding: 0 10px;
  color: ${colors.text.link};

  &:hover {
    color: ${Theme.colors.buttonHoverColor};
    svg {
      fill: ${Theme.colors.buttonHoverColor};
    }
  }
  &:first-child {
    padding-left: 0;
    margin-left: -10px;
  }
`;

export const ActionLink = styled.a`
  border-right: ${(props) => (props.last ? '0px' : '1px')} solid
    ${colors.border};

  ${ActionLinkCss};
`;

export const PopoverHeader = styled.div`
  font-weight: 600;
  display: none;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: block;
    margin-bottom: 10px;
  }
`;
export const PopoverBody = styled.div`
  padding: 15px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 100%;
    border: none;
    box-shadow: none;
  }
`;

export const ClearButton = styled.div`
  color: ${colors.text.link};
  font-size: 14px;
  cursor: pointer;
  font-weight: 400;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: none;
  }
`;
